import React from 'react'

import Error from '../landing/error/Error'

const PageNotFound = props => {
  return () => <Error code={404} />
}

export default PageNotFound
